export default __webpack_public_path__ + "static/media/2481.a30f4493.svg";